/**
 * Extract UTM parameters from the current URL
 * @returns {Object} Object containing utm_source, utm_medium, utm_campaign
 */
export const extractUTMParameters = () => {
  const urlParams = new URLSearchParams(window.location.search);
  
  return {
    utm_source: urlParams.get('utm_source') || '',
    utm_medium: urlParams.get('utm_medium') || '',
    utm_campaign: urlParams.get('utm_campaign') || ''
  };
};

/**
 * Store UTM parameters in localStorage for later use
 * @param {Object} utmParams - UTM parameters object
 */
export const storeUTMParameters = (utmParams) => {
  if (utmParams.utm_source || utmParams.utm_medium || utmParams.utm_campaign) {
    localStorage.setItem('utm_parameters', JSON.stringify(utmParams));
  }
};

/**
 * Get stored UTM parameters from localStorage
 * @returns {Object} Stored UTM parameters
 */
export const getStoredUTMParameters = () => {
  const stored = localStorage.getItem('utm_parameters');
  return stored ? JSON.parse(stored) : { utm_source: '', utm_medium: '', utm_campaign: '' };
};

/**
 * Clear stored UTM parameters from localStorage
 */
export const clearUTMParameters = () => {
  localStorage.removeItem('utm_parameters');
};

/**
 * Build a URL with UTM parameters preserved
 * @param {string} basePath - The base path to navigate to
 * @returns {string} URL with UTM parameters appended if they exist
 */
export const buildUrlWithUTM = (basePath) => {
  const utmParams = getStoredUTMParameters();
  const hasUtm = utmParams.utm_source || utmParams.utm_medium || utmParams.utm_campaign;
  
  if (hasUtm) {
    const params = new URLSearchParams();
    if (utmParams.utm_source) params.append('utm_source', utmParams.utm_source);
    if (utmParams.utm_medium) params.append('utm_medium', utmParams.utm_medium);
    if (utmParams.utm_campaign) params.append('utm_campaign', utmParams.utm_campaign);
    return `${basePath}?${params.toString()}`;
  }
  return basePath;
};